export interface GrupoColor {
  left: string;
  header: string;
  text: string;
  dot: string;
  block: string;
}

const PALETTE: GrupoColor[] = [
  { left: "border-l-blue-500", header: "bg-blue-50", text: "text-blue-800", dot: "bg-blue-500", block: "bg-blue-500 text-white" },
  { left: "border-l-emerald-500", header: "bg-emerald-50", text: "text-emerald-800", dot: "bg-emerald-500", block: "bg-emerald-500 text-white" },
  { left: "border-l-violet-500", header: "bg-violet-50", text: "text-violet-800", dot: "bg-violet-500", block: "bg-violet-600 text-white" },
  { left: "border-l-amber-500", header: "bg-amber-50", text: "text-amber-800", dot: "bg-amber-500", block: "bg-amber-500 text-white" },
  { left: "border-l-rose-500", header: "bg-rose-50", text: "text-rose-800", dot: "bg-rose-500", block: "bg-rose-500 text-white" },
  { left: "border-l-cyan-500", header: "bg-cyan-50", text: "text-cyan-800", dot: "bg-cyan-500", block: "bg-cyan-500 text-white" },
];

const DEFAULT: GrupoColor = {
  left: "border-l-slate-400",
  header: "bg-slate-50",
  text: "text-slate-800",
  dot: "bg-slate-400",
  block: "bg-slate-600 text-white",
};

const EVENTO: GrupoColor = {
  left: "border-l-violet-600",
  header: "bg-violet-50",
  text: "text-violet-900",
  dot: "bg-violet-500",
  block: "bg-violet-600 text-white",
};

const CONCLUIDA: GrupoColor = {
  left: "border-l-emerald-500",
  header: "bg-emerald-50",
  text: "text-emerald-800",
  dot: "bg-emerald-500",
  block: "bg-emerald-500 text-white",
};

export function cardColor(tarefa: { grupoId: string | null; tipo?: string; status: string }): GrupoColor {
  if (tarefa.status === "concluida") return CONCLUIDA;
  if (tarefa.tipo === "evento") return EVENTO;
  if (!tarefa.grupoId) return DEFAULT;
  let hash = 0;
  for (let i = 0; i < tarefa.grupoId.length; i++) hash += tarefa.grupoId.charCodeAt(i);
  return PALETTE[hash % PALETTE.length];
}
